export enum IconButtonType {
  NONE = 'NONE',
  OUTLINED = 'OUTLINED',
  OUTLINED_COLOR = 'OUTLINED_COLOR',
  SIMPLE = 'SIMPLE',
  SOLID = 'SOLID',
  SOLID_COLOR = 'SOLID_COLOR',
  SOLID_GRADIENT = 'SOLID_GRADIENT'
}
